import React from "react";
import { Container } from "@material-ui/core";
import styles from './styles.styles';
import './progress.css';

export default () => {
    const classes = styles();

  return (
    <Container className={classes.circularProgress}>
      <div className="sk-chase">
        <div className="sk-chase-dot"></div>
        <div className="sk-chase-dot"></div>
        <div className="sk-chase-dot"></div>
        <div className="sk-chase-dot"></div>
        <div className="sk-chase-dot"></div>
        <div className="sk-chase-dot"></div>
      </div>
    </Container>
  );
};
